<template>
  <div>
    <v-row>
      <v-col cols="12" sm="4">
        <PrenameCard age="adult" v-model="UserInfo_prenameId" />
      </v-col>
    </v-row>
    <NameSurnameTHCard
      :value_nameTh="UserInfo_nameTh"
      @input_nameTh="UserInfo_nameTh = $event"
      :value_surnameTh="UserInfo_surnameTh"
      @input_surnameTh="UserInfo_surnameTh = $event"
      v-bind:textLabelNameTh="$t('info_card.name_th')"
      v-bind:textPlaceholderNameTh="$t('info_card.name_th')"
      v-bind:textHintNameTh="$t('info_card.name_th_hint')"
      v-bind:textLabelSurnameTh="$t('info_card.surname_th')"
      v-bind:textPlaceholderSurnameTh="$t('info_card.surname_th')"
      v-bind:textHintSurnameTh="$t('info_card.surname_th_hint')"
    />
    <NameSurnameENCard
      :value_nameEn="UserInfo_nameEn"
      @input_nameEn="UserInfo_nameEn = $event"
      :value_surnameEn="UserInfo_surnameEn"
      @input_surnameEn="UserInfo_surnameEn = $event"
    />
    <v-divider></v-divider>
    <ThaiOrOtherCard
      v-model="UserInfo_thaiOrOtherNation"
      v-bind:textThai="$t('info_card.nation_thai')"
      v-bind:textOther="$t('info_card.nation_foreigner')"
    />
    <v-row>
      <v-col cols="12" sm="4">
        <NationCard
          :and_passport="true"
          v-model="UserInfo_nationId"
          v-if="this.UserInfo_thaiOrOtherNation === 'other'"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="4">
        <CitizenIDCard
          v-model="UserInfo_citizenId"
          :and_passport="true"
          :disabled="true"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-row>
      <v-col cols="12" sm="6" md="4">
        <MobileCard v-model="UserInfo_mobile" />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <EmailCard v-model="UserInfo_email" />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <DateSelectCard
          v-model="UserInfo_birthday"
          v-bind:label="$t('info_card.birthday')"
          v-bind:rules="requiredRules"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PrenameCard from "@/components/info_cards/Prename";
import NameSurnameTHCard from "@/components/info_cards/NameTH";
import NameSurnameENCard from "@/components/info_cards/NameEN";
import ThaiOrOtherCard from "@/components/info_cards/ThaiOrOther";
import NationCard from "@/components/info_cards/Nation";
import CitizenIDCard from "@/components/info_cards/CitizenID2";
import MobileCard from "@/components/info_cards/Mobile";
import EmailCard from "@/components/info_cards/Email";
import { objectTranslator } from "../../helper/translator";
import validator from "../../helper/validator";
import DateSelectCard from "@/components/info_cards/DateSelect";

export default {
  name: "UserInfoCard",
  props: [
    "value_prenameId",
    "value_nameTh",
    "value_surnameTh",
    "value_nameEn",
    "value_surnameEn",
    "value_thaiOrOtherNation",
    "value_nationId",
    "value_citizenId",
    "value_mobile",
    "value_email",
    "value_birthday",
  ],
  data: function() {
    return {
      requiredRules: [validator.required],
    };
  },
  components: {
    PrenameCard,
    NameSurnameTHCard,
    NameSurnameENCard,
    ThaiOrOtherCard,
    NationCard,
    CitizenIDCard,
    MobileCard,
    EmailCard,
    DateSelectCard,
  },

  methods: {
    objectTranslator,
  },
  computed: {
    UserInfo_prenameId: {
      get() {
        return this.value_prenameId;
      },
      set(value) {
        this.$emit("input_prenameId", value);
      },
    },
    UserInfo_nameTh: {
      get() {
        return this.value_nameTh;
      },
      set(value) {
        this.$emit("input_nameTh", value);
      },
    },
    UserInfo_surnameTh: {
      get() {
        return this.value_surnameTh;
      },
      set(value) {
        this.$emit("input_surnameTh", value);
      },
    },
    UserInfo_nameEn: {
      get() {
        return this.value_nameEn;
      },
      set(value) {
        this.$emit("input_nameEn", value);
      },
    },
    UserInfo_surnameEn: {
      get() {
        return this.value_surnameEn;
      },
      set(value) {
        this.$emit("input_surnameEn", value);
      },
    },
    UserInfo_thaiOrOtherNation: {
      get() {
        return this.value_thaiOrOtherNation;
      },
      set(value) {
        this.$emit("input_thaiOrOtherNation", value);
      },
    },
    UserInfo_citizenId: {
      get() {
        return this.value_citizenId;
      },
      set(value) {
        this.$emit("input_citizenId", value);
      },
    },
    UserInfo_nationId: {
      get() {
        return this.value_nationId;
      },
      set(value) {
        this.$emit("input_nationId", value);
      },
    },
    UserInfo_mobile: {
      get() {
        return this.value_mobile;
      },
      set(value) {
        this.$emit("input_mobile", value);
      },
    },
    UserInfo_email: {
      get() {
        return this.value_email;
      },
      set(value) {
        this.$emit("input_email", value);
      },
    },
    UserInfo_birthday: {
      get() {
        return this.value_birthday;
      },
      set(value) {
        this.$emit("input_birthday", value);
      },
    },
  },
  mounted: function() {},
};
</script>
